<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)"
          class="max-h70vh">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic"
            class="max-h70vh">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="max-h70vh">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      tile
                      color="transparent"
                      flat>
                      <v-card-text class="background-trans-style">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.alumni') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="6" class="d-flex">
              <v-card
                class="d-flex flex-column w100">
                <v-img
                  class="align-end flex-grow-0 flex-shrink-1"
                  height="400px"
                  :src="require('../assets/alumni-rini.jpg')"
                  position="top">
                </v-img>
                <v-card-text class="black--text flex-grow-1 flex-shrink-0 pb-0">
                  <div class="font-weight-bold color-main">
                    D3 Business Administration 1990
                  </div>
                  <h2 class="text-md-h5 font-weight-bold mb-5 sub-title-page color-main">
                    Dastrini Sessions
                  </h2>
                  <p class="font-weight-bold color-main font-italic">
                    Rini is working in Stelar London Ltd. as Sales and Event Manager. Prior to that, she was a VIP Personal Shopper for Selfridges Co. London, Senior Fraudulent Officer for Shop Direct Limited, the UK. Rini also manages her own bussiness.
                  </p>
                  <p>
                    I have many memorable experiences when I was studying at PNB. It is hard to pick just one, but one thing is for sure. During my degree, I learned to prepare myself to get my dream job once I graduated. Even before graduating, I manage to secure a job as a secretary in Kartika Plaza Hotel, Kuta.
                  </p>
                  <p>
                    Everything I learned at the time was not only learning about the theories from textbooks, butI was also learning many practical skills i.e. typing, IT, English speaking, stenography, office skills, etc.
                  </p>
                  <p>
                    My favorite subject was management. I was lucky to be thought by one of the best lecturers I know Mr. Wirga. He inspired me to be a manager one day, and here I am now a Sales and Event Manager for STELAR Ltd in London, the UK. I'm proud to be PNB graduate.
                  </p>
                  <p>
                    Another best memory when I was a student was my typing lesson. This particular lesson was always a battle about who would get the best typewriter in the lab. It was like a running competition who would get there first, the prize was to get the best typewriter, and the loser would have to make do with whatever was left.
                  </p>
                </v-card-text>
                <v-card-text class="black--text pt-0">
                  <div class="font-weight-bold sub-title-page mb-3 color-main">
                    Top Tips from Rini:
                  </div>
                  <blockquote class="color-main">
                    <ul class="color-main">
                      <li>Always focus on your study, be confident, never stop learning, never give up!!!</li>
                      <li>Study hard, finish your study, and be ready for any job opportunities out there!!</li>
                    </ul>
                  </blockquote>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <v-card
                class="d-flex flex-column w100">
                <v-img
                  class="align-end flex-grow-0 flex-shrink-1"
                  height="400px"
                  :src="require('../assets/alumni-pande.jpeg')"
                  position="top">
                </v-img>
                <v-card-text class="black--text flex-grow-1 flex-shrink-0 pb-0">
                  <div class="font-weight-bold color-main">
                    D3 Accounting 1990 & Magister in Marketing Management
                  </div>
                  <h2 class="text-md-h5 font-weight-bold mb-5 sub-title-page color-main">
                    I Wyn Pande Sutawan S.Tr.Par., MM., CHA
                  </h2>
                  <p class="font-weight-bold color-main font-italic">
                    Pande is a Group General Manager of Pita Maha Group. He also has experiences with Garuda Indonesia, Singapore Airline, and Banyan Tree Resort.
                  </p>
                  <p>
                    My best experience while studying at PNB was the learning process. It was enjoyable, fun and also made me focus on the lessons.
                  </p>
                  <p>
                    Human relations and manners are the most important competencies in my career development. These made me who I am now as a Group General Manager of Pita Maha Group, which oversees many companies in various fields such as hospitality, health, and law with thousands of employees in it.
                  </p>
                  <p>
                    Seven weeks at the military camp made me learn something new in my life such as, self-understanding, discipline, teamwork, and respect for others.
                  </p>
                  <p>
                    I was at PNB in 1987, under Udayana University, and what I remember I was happy to be part of PNB, and that I started my professional life from PNB.
                  </p>
                  <p>
                    My best memory as a student at PNB was in 1987, it was all quiet, no shop, no entertainment, no public transport, just studying.
                  </p>
                </v-card-text>
                <v-card-text class="black--text pt-0">
                  <div class="font-weight-bold sub-title-page mb-3 color-main">
                    Top Tips from Pande:
                  </div>
                  <blockquote class="color-main">
                    Life is a journey, enjoy the process and what comes around goes around. Work and think smart, and be the trendsetter. Don’t just be a follower.
                  </blockquote>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Alumni',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/cov-alumni.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pengabdian';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
